import React from 'react'
import { Alert } from '@mui/material';
import "./alert.css"

function AlertBox({type, msg}) {
  return (
    <Alert className='alert_box' severity={type}>{msg}</Alert>
  )
}

// const AlertBox = React.forwardRef(({type, msg}, ref)=>{
//   return (
//     <Alert className='alert_box' severity={type}>{msg}</Alert>
//   )
// })

export default AlertBox